module.exports = __webpack_public_path__ + "static/2-b09c3c7b88fdc4905d2c5ef75a51fb2d.svg";